// internal-deps
import { format } from "@swiggy-private/js-utils";
import { GlobalHeaderState, HTTP_METHODS, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";

// constants
import { DOWNSTREAM_ENDPOINTS, DOWNSTREAM_HOSTS } from "@payment-client/constants/Hosts";

// helpers/utils
import { makeDownstreamApiCall, unwrapResponseWithCode } from "@payment-client/utils/Api";
import { getCreateOrderParams } from "@payment-client/helpers/DineoutDirectPlaceOrder";

// interfaces
import { IDineoutCreateOrderResponse, IDineoutOrderStatusResponse } from "@payment-client/interfaces/Order";

export async function createDineoutOrder(): Promise<IDineoutCreateOrderResponse["data"]> {
    const userId = GlobalHeaderState.getHeader(SwgyHeaderKeysList.userId);
    const params = getCreateOrderParams(userId);
    // const createDineoutOrderParams = getCreateOrderParams(userId, "DEAL_TICKET_PAYMENT");
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { payment_info, cartType } = params;
    try {
        const response = unwrapResponseWithCode(
            await makeDownstreamApiCall<IDineoutCreateOrderResponse>({
                apiHost: DOWNSTREAM_HOSTS.DO_HOST,
                endpoint: DOWNSTREAM_ENDPOINTS.DO_PLACE_ORDER,
                options: {
                    method: HTTP_METHODS.POST,
                    body: JSON.stringify({
                        ...params,
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        payment_type: payment_info.payment_type,
                    }),
                },
                searchParams: {
                    cartType,
                },
            }),
        );

        return response.toPromise();
    } catch (e) {
        return Promise.reject("Something went wrong in reserving your table.");
    }
}

export async function getDineoutOrderStatus(orderId: string): Promise<IDineoutOrderStatusResponse["data"]> {
    try {
        const response = unwrapResponseWithCode(
            await makeDownstreamApiCall<IDineoutOrderStatusResponse>({
                apiHost: DOWNSTREAM_HOSTS.DO_HOST,
                endpoint: format(DOWNSTREAM_ENDPOINTS.DO_CONFIRM_ORDER, orderId),
                options: {
                    method: HTTP_METHODS.GET,
                },
            }),
        );
        return response.toPromise();
    } catch (e) {
        return Promise.reject("Something went wrong in fetching the reservation status.");
    }
}
